const UNITS = ['KB', 'MB', 'GB', 'TB'];

/** Formats a byte count for people: "0 B", "512 B", "1.5 KB", "5.0 MB". */
export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(1)} ${UNITS[unit]}`;
};
